import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import {  facebookIcon, youtubeIcon, instagramIcon } from '../constants/icons';
import logo from "../assets/logo/footer_logo.png"

function MainFooter() {
    return (
        <div className="main-footer">
            <Container>
                <Navbar.Brand href="/">
                      <img src={logo} alt="Logo"  height={70} />
                </Navbar.Brand>
                {/* <div className="social-links">
                    <Nav.Link href="https://facebook.com" target="_blank">
                        {facebookIcon}
                    </Nav.Link>
                    <Nav.Link href="https://youtube.com" target="_blank">
                        {youtubeIcon}
                    </Nav.Link>
                    <Nav.Link href="https://instagram.com" target="_blank">
                        {instagramIcon}
                    </Nav.Link>
                </div> */}
            </Container>
        </div>
    );
}

export default MainFooter;